module.exports = require("./mas-TZ.js");